import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../../UIAssetKeys';
import Forces from '../../common/Forces';

export default class ToppingSprite extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0,0, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Topping_4_1);

    this.fade = false;

    this.mass = 1.0;
    this.gravity = 0;
    this.k = 0.0;

    this.pos = null;
    this.vel = null;
    this.lifetime = 2;
    this.age = 0;
    this.halflife = 0;

    this.gravityForce = null;
    this.totalForce = null;

    this.gravityForce = new Phaser.Math.Vector2();
    this.dragForce = new Phaser.Math.Vector2();
    this.totalForce = new Phaser.Math.Vector2();
    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);
    this.pos = new Phaser.Math.Vector2();
    this.vel = new Phaser.Math.Vector2();

    this.zoomScale = 0.8;
    this.cherryWidth = this.width * this.zoomScale;
    this.cherryHeight = this.height * this.zoomScale;
  }

  reset (x,y,vx,vy,lifetime, toppingId, toppingType, isCherry = 0) {
    this.isCherry = isCherry;

    this.pos.x = x;
    this.pos.y = y;
    this.vel.x = vx;
    this.vel.y = vy;
    this.lifetime = lifetime;
    this.halflife = lifetime / 2;
    this.age = 0;
    this.alpha = 1;
    this.scale = this.zoomScale;
    this.setFrame(`Topping+${toppingId}+${toppingType}`).setOrigin(0.5);
    this.angle = 0;
    this.update();
  }

  update () {
    this.x = this.pos.x;
    this.y = this.pos.y;
  }

  move (dt) {
    this.pos.add({ x: this.vel.x * dt, y: this.vel.y * dt });
    if (this.isCherry === 0) this.angle += this.vel.x * dt;
  }

  updateAccel () {
    this.totalForce.multiply({ x: 1 / this.mass,y: 1 / this.mass });
  }

  updateVelocity (dt) {
    this.vel.add({ x: this.totalForce.x * dt,y: this.totalForce.y * dt });
  }

  tick (dt) {
    this.move(dt);

    this.updateAccel();
    this.updateVelocity(dt);

    this.age += dt;

    if (this.fade && this.age > this.halflife) {
      this.alpha -= 0.8 * dt;
    }

    if (this.isCherry === 0) {
      return this.age < this.lifetime;
    }
    else {
      return this.pos.y <= this.isCherry;
    }
  }
}